




























import Vue from 'vue';
import { TeacherOnSubjectAllocationDto } from '@/models/planning/TeacherOnSubjectAllocationDto';
import { mapActions, mapGetters } from 'vuex';
import APISTATE from '@/enums/APISTATE';

export default Vue.extend({
  name: 'classsubjectteacher-edit',
  props: {
    teacherOnSubjectAllocation: {
      type: Object as () => TeacherOnSubjectAllocationDto,
    }
  },
  data: () => ({
    hours: 0 as number,
    percentage: 0,
    state: '0',
  }),
  mounted() {
    this.updateInputFields();
  },
  methods: {
    ...mapActions('distributionStore', ['updateTeacherOnSubjectAllocation']),
    updateInputFields() {
      this.percentage = (this.hoursForPlanning === 0) ? 0 : Math.round((this.teacherOnSubjectAllocation.hours / this.hoursForPlanning * 100) * 100) / 100;
      this.hours = this.teacherOnSubjectAllocation.hours;
    },
    async percentageUpdated() {
      this.hours = Math.round((this.hoursForPlanning * this.percentage / 100) * 100) / 100;
      await this.updateAllocation();
    },
    async hoursUpdated() {
      this.percentage = (this.hoursForPlanning === 0) ? 0 : Math.round((this.inputHours / this.hoursForPlanning * 100) * 100) / 100;
      await this.updateAllocation();
    },
    async updateAllocation() {
      try {
        const allocation = {
          relTeacher: this.teacherOnSubjectAllocation.relTeacher,
          relClassSubject: this.teacherOnSubjectAllocation.relClassSubject,
          state: this.state,
          hours: this.inputHours
        } as TeacherOnSubjectAllocationDto;
        await this.updateTeacherOnSubjectAllocation(allocation);
      }
      catch (error) {
        this.$buefy.toast.open({
          message: 'Fejl ved opdatering af allokering.',
          type: 'is-danger'
        });
      }
    },

  },
  computed: {
    ...mapGetters('classSubjectStore', ['classSubjectHoursForPlanning']),
    ...mapGetters('distributionStore', ['distributionApiState']),
    teacherName() {
      const initials = `${this.teacherOnSubjectAllocation.relTeacherNavigation.initials}`.toUpperCase();
      const name = `${this.teacherOnSubjectAllocation.relTeacherNavigation.firstName} ${this.teacherOnSubjectAllocation.relTeacherNavigation.lastName}`;
      return `${initials} - ${name}`;
    },
    hoursForPlanning() {
      return this.classSubjectHoursForPlanning(this.teacherOnSubjectAllocation.relClassSubject);
    },
    loading() {
      return this.distributionApiState === APISTATE.LOADING;
    },
    inputHours() {
      if (this.hours) {
        return parseFloat(this.hours);
      }
      return 0;
    },
    inputPercentage() {
      if (this.percentage) {
        return parseFloat(this.percentage);
      }
      return 0;
    }
  },
  watch: {
    'teacherOnSubjectAllocation': {
      deep: true,
      handler() {
        this.updateInputFields();
      }
    }
  }
})
